// extracted by mini-css-extract-plugin
module.exports = {"container":"BarItem_container__PyDoU","number":"BarItem_number__3PKdR","notLast":"BarItem_notLast__HELY8","text":"BarItem_text__1CJqP","image":"BarItem_image__1anj_"};